import {PauseUnpause, PauseUnpauseAction} from '../../components/pause-unpause.js';

export function pauseButton() {
    PauseUnpause.instance.onClick(PauseUnpauseAction.Pause);
}
